import Select from '@/components/common/Select';
import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useRouterPath } from '@/functions/routerPath';
import { setState } from '@/commonTypes';

export default function Filters({
  setPageNumber,
  sortParams,
}: {
  setPageNumber?: setState<number | string>;
  sortParams?: {
    sort?: string | null;
    orderBy?: string | null;
  };
}) {
  const tCommon = useTranslations('common');
  const router = useRouter();
  const routerPath = useRouterPath();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const [filters, setFilters] = useState([
    { id: 1, params: { orderBy: 'created_at', sort: 'desc' }, title: tCommon('newest') },
    { id: 2, params: { orderBy: 'created_at', sort: 'asc' }, title: tCommon('oldest') },
    { id: 3, params: { orderBy: 'view_num', sort: 'desc' }, title: tCommon('mostViewed') },
    { id: 4, params: { orderBy: 'rate', sort: 'desc' }, title: tCommon('mostRated') },

    // {id:1, params:{orderBy:"createdAt", sort:"desc"}, title:"طولانی‌ترین"},
  ]);
  const [selectedFilter, setSelectedFilter] = useState(
    filters.find(
      (filter) =>
        filter.params.sort === sortParams?.sort && filter.params.orderBy === sortParams?.orderBy,
    ),
  );

  useEffect(() => {
    setSelectedFilter(
      filters.find(
        (filter) =>
          filter.params.sort === sortParams?.sort && filter.params.orderBy === sortParams?.orderBy,
      ),
    );
  }, [sortParams]);

  return (
    <div className={`${styles.sortContainer}`}>
      <span className={styles.select_lbl}>{tCommon('sort')}:</span>
      <Select
        extraButtonStyle={`${styles.select}`}
        theme="dark"
        fillIcon={'var(--text-mut2)'}
        iconSize="18px"
        list={filters}
        title="sortSelect"
        showTitle={false}
        value={selectedFilter?.id}
        className={`${styles.selectWrapper}`}
        placeholder={tCommon('choose')}
        fillFormFunction={(id) => {
          let filter = filters?.filter((x) => x.id == id)?.[0];
          const params = new URLSearchParams(searchParams.toString());
          if (filter) {
            params.set('sort', filter?.params?.sort);
            params.set('orderBy', filter?.params?.orderBy);
            setPageNumber && params.set('page', '1');
          }

          // router.push(routerPath(`${pathname}?${params.toString()}`));
          const newPath = pathname.replace(/\/page\/\d+$/, '');
          setPageNumber && setPageNumber(1);
          router.push(`${newPath}${params.toString() ? `?${params.toString()}` : ''}`);
        }}
      />
    </div>
  );
}
